import { render } from "./affiliate-navigation-bar-mobile.vue?vue&type=template&id=4b0d18d8&scoped=true&ts=true"
import script from "./affiliate-navigation-bar-mobile.vue?vue&type=script&lang=ts"
export * from "./affiliate-navigation-bar-mobile.vue?vue&type=script&lang=ts"

import "./affiliate-navigation-bar-mobile.vue?vue&type=style&index=0&id=4b0d18d8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b0d18d8"]])

export default __exports__